module.exports = __webpack_public_path__ + "static/media/tn.51932f4a.svg";